<div class="app-alert display-flex" *ngIf="resetPasswordVisibility">
    <div class="app-alert__box bg-light box-shadow app-alert__box--padding"
        data-testid="app-old-alert">
        <div class="app-alert__message app-alert__message--block font-15 cursor-default">
            {{ subtitles.setSubtitle(1935) }}
        </div>
        <input type="password"
               [(ngModel)]="newPassword"
               class="border-input app-alert__input"
               [placeholder]="subtitles.setSubtitle(1101)" />
        <input type="password"
               [(ngModel)]="newPasswordRepeat"
               class="border-input app-alert__input"
               [placeholder]="subtitles.setSubtitle(1340)" />
        <div class="app-alert__buttons-box">
            <input type="button"
                   [value]="subtitles.setSubtitle(71)"
                   class="app-alert__button bg-cancel color-light font-bold font-14 cursor-pointer"
                   (click)="goLogin()" />
            <input type="button"
                   [value]="subtitles.setSubtitle(970)"
                   class="app-alert__button bg-ok color-light font-bold font-14 cursor-pointer"
                   (click)="sendNewPassword()" />
        </div>
    </div>
</div>
